import rawSkills from '../data/skills.json';

export type SkillEffect = 'burst' | 'seal' | 'fire_burst' | 'heal';

export type SkillDefinition = {
  id: string;
  name_th: string;
  name_en: string;
  school: string;
  tags: string[];
  knowledge_cost: number;
  cooldown: number;
  power: number;
  range: number;
  effect: SkillEffect;
  short_name_th: string;
};

export const KNOWLEDGE_CAPACITY = 16;
export const STARTER_SKILLS = rawSkills as SkillDefinition[];

export function getSkillForSlot(slot: number): SkillDefinition | undefined {
  return STARTER_SKILLS[slot];
}

export function totalKnowledgeCost(skills: SkillDefinition[] = STARTER_SKILLS): number {
  return skills.reduce((total, skill) => total + skill.knowledge_cost, 0);
}

export function cooldownAfterHaste(skill: SkillDefinition, haste: number): number {
  const safeHaste = Math.max(0, Math.min(0.75, haste));
  return Math.max(0.05, Math.max(0.05, skill.cooldown) * (1 - safeHaste));
}
